import { DETERMINAR_PAGINA_ATUAL_ROTA_ITINERARIO } from '../types'

export default function determinarPaginaAtualRotasItinerario (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_ROTA_ITINERARIO,
    payload: paginaAtual
  }
}
